export enum DtwinConfigurationType {
  SELF_SUPPORTING = "SELF_SUPPORTING",
  GLOBAL_AND_SPECIFIC = "GLOBAL_AND_SPECIFIC",
}
